import graphql__6d4052c5de76043943ce from "./__generated__/ContributionsDatavizListThemeRouteQuery.graphql.js";import { graphql } from "react-relay";
import { useParams, useOutletContext } from "react-router";

import AppQueryRenderer from "../AppQueryRenderer";
import ContributionsDatavizListTheme from "../ParticipativeModule/Visualizations/ContributionsDataviz/ContributionsDatavizListTheme";
import { ResourcesListProvider } from "../ResourcesList/resourcesList";
import ResourcesListUrlSearchSync from "../ResourcesList/ResourcesListUrlSearchSync";

const ContributionsDatavizListThemeRoute = props => {
  const { participativeModuleSlug, themeSlug } = useParams();
  const { contributionsPerPage: contributionsCount } = useOutletContext();

  return (
    <AppQueryRenderer
      query={ContributionsDatavizListThemeRouteQuery}
      variables={{ participativeModuleSlug, themeSlug, contributionsCount }}
      additionalProps={props}
    >
      {props => (
        <ResourcesListProvider key={themeSlug}>
          <ResourcesListUrlSearchSync />
          <ContributionsDatavizListTheme {...props} />
        </ResourcesListProvider>
      )}
    </AppQueryRenderer>
  );
};

const ContributionsDatavizListThemeRouteQuery = graphql__6d4052c5de76043943ce;

export default ContributionsDatavizListThemeRoute;
